import React from 'react';
import userInformations from '../../userInformation/user_informations';
import './Home.css';

export default class TitleHome extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      name: userInformations.getUserName()
    }
  }

  render() {
    return (
      <div className="container-xl title-wrapper px-xl-0 px-5">
        <div className="fs-5">Mon espace personnel</div>
        <div className="fs-1 fw-bold">Bonjour {this.state.name}</div>
        <div className="fs-1 fw-bold">Bienvenue sur votre espace personnel</div>
      </div>
    );
  }
}
